import { t } from '../../../strings/i18n';
import maximumFourDigits from '../../../xform/validators/maximumFourDigits';
const nicknameConfig = () => [
    'nickname',
    undefined,
    'ENABLED',
    [maximumFourDigits(t('errors.invalidNickname'))]
];
export default nicknameConfig;
